module.exports = __webpack_public_path__ + "img/meeting_minutes.17290e3a.svg";